import * as Styled from "./ToggleButton.styles";

import { Stack, SxProps, Theme, Typography, useMediaQuery } from "@mui/material";

type ToggleButtonProps = {
  option: number;
  setOption: React.Dispatch<React.SetStateAction<number>>;
  options: Array<string>;
  spacing?: number;
  height?: string;
  padding?: string;
  labelVariant?: any;
  onClick: (index: number) => void;
  containerSX?: SxProps<Theme>
  buttonSX?: SxProps<Theme>
  selectedButtonColors?: { backgroundColor?: string, textColor?: string };
};

const ToggleButton = ({
  option,
  options,
  spacing = 8,
  height = "40px",
  padding = "0px 24px",
  labelVariant = "modalSubtitle",
  onClick,
  containerSX,
  buttonSX,
  selectedButtonColors
}: ToggleButtonProps) => {
  const isDesktop = useMediaQuery((theme: any) =>
    theme.breakpoints.up("desktop")
  );
  return (
    <Stack direction="row" sx={containerSX}>
      {options.map((label: string, index: number) => {
        return (
          <Styled.ToggleButtonOption
            key={index}
            variant={"text"}
            onClick={() => onClick(index)}
            index={index}
            option={option}
            optionslength={options.length}
            spacing={spacing}
            fullWidth={!isDesktop}
            height={height}
            padding={padding}
            sx={buttonSX}
            selectedButtonColors={selectedButtonColors}
          >
            <Typography variant={labelVariant}>{label}</Typography>
          </Styled.ToggleButtonOption>
        );
      })}
    </Stack>
  );
};

export default ToggleButton;
